var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCosmetics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6922 21.5648L39.3594 21.232L46.5239 14.2044C46.8487 13.8769 47.1057 13.4886 47.2801 13.0616C47.4545 12.6346 47.5429 12.1774 47.5402 11.7162V4.11142C47.5368 3.41954 47.3286 2.74417 46.9419 2.17041C46.5553 1.59666 46.0074 1.15019 45.3675 0.887285C44.7292 0.618913 44.0258 0.545589 43.346 0.676567C42.6662 0.807544 42.0404 1.13695 41.5476 1.62323L30.6491 12.5217L30.1864 12.059C30.0458 11.9183 29.855 11.8393 29.6561 11.8393C29.4572 11.8393 29.2664 11.9183 29.1258 12.059L21.7746 19.4101L20.1716 17.8071C19.8168 17.4522 19.3355 17.2529 18.8337 17.2529C18.3319 17.2529 17.8506 17.4522 17.4958 17.8071L4.16315 31.1397L4.15918 31.1437C3.06896 32.2404 2.45703 33.724 2.45703 35.2704C2.45703 36.8168 3.06896 38.3004 4.15917 39.3971L12.4425 47.6804L12.4465 47.6844C13.5432 48.7746 15.0268 49.3866 16.5732 49.3866C18.1196 49.3866 19.6032 48.7746 20.6999 47.6844L20.7039 47.6804L34.0365 34.3478C34.7754 33.6089 34.7754 32.4109 34.0365 31.672L32.3411 29.9766L39.6922 22.6254C39.9851 22.3326 39.9851 21.8577 39.6922 21.5648ZM29.8321 27.4676L35.1161 22.1835L29.5677 16.6352L24.2837 21.9192L29.8321 27.4676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmetics);
export default __webpack_public_path__ + "static/media/Cosmetics.e84673246b60e9f8c79cb62ba1efa6d2.svg";
export { ForwardRef as ReactComponent };